import { Currency } from '@/core/currency/interfaces';

const ALL: Currency = {
    name: 'Albanian Lek',
    demonym: 'Albanian',
    majorSingle: 'Lek',
    majorPlural: 'Lekë',
    codeNumeric: '008',
    symbol: 'L',
    symbolNative: 'L',
    minorSingle: 'Qindarka',
    minorPlural: 'Qindarka',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ALL',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ALL;
